// TaskDetails.js
import React from "react";
import { Badge, Button, ListGroup } from "react-bootstrap";

const TaskDetails = ({ task, translations: t, compact, handleDownload }) => {
  return (
    <div>
      <div>
        <strong>{t.taskNumber}{task.referenceNumber} - {task.chapter.title}</strong>
        <Badge bg="secondary" className="ms-2">
          {task.chapter.book.title}
        </Badge>
      </div>
      <div className="text-muted small">
        {t.createdOn}{new Date(task.createdAt).toLocaleString()}
      </div>
      {!compact && (
        <>
          <div className="mt-2">
            <strong>{t.instructions}</strong> {task.instructions || t.none}
          </div>
          {task.comments && task.comments.length > 0 && (
            <div className="mt-2">
              <strong>{t.comments}</strong>
              <ListGroup variant="flush" className="mt-2">
                {task.comments.map(comment => {
                  return (
                    <ListGroup.Item key={comment.id} className="rounded mb-2 p-2" style={{ border: '1px solid #ddd' }}>
                      "{comment.text}"
                      {comment.pageNumber && (
                        <Badge bg="secondary" className="ms-2">
                          {t.pageNumber}{comment.pageNumber}
                        </Badge>
                      )}
                      {comment.sugestionType && (
                        <Badge bg="info" pill="true" className="ms-2">
                          {comment.sugestionType}
                        </Badge>
                      )}
                      {comment.imageBase64 && comment.nameImageBase64 && (
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="ms-2"
                          onClick={() => handleDownload(comment.imageBase64, comment.nameImageBase64)}
                        >
                          Download: {comment.nameImageBase64}
                        </Button>
                      )}
                      <div className="text-muted small">
                        {new Date(comment.createdAt).toLocaleString()}
                      </div>
                      <div className="text-end text-muted small">
                        - {comment.creator.name}
                      </div>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default TaskDetails;